<template>
  <Messages :messages="messages" />

  <div v-if="loaded && description">
    <DescriptionWrapper :description="description"
                        :edit-mode="editMode"
                        :comment-points="commentPoints"
                        @toggle-edit-mode="toggleEditMode"
                        @delete-description="deleteDescription"
                        @save-description="saveDescription"
                        @reload="reload"
    />
  </div>

  <div v-if="loaded && !description">
    <InputHider :toggle-class="toggleClass" :save-handler="createDescription" :points-gained="user ? point : 0" :placeholder="'Doplň informácie'">
      <ckeditor :editor="editor" v-model="editorText" :config="editorConfig"></ckeditor>
    </InputHider>
  </div>

</template>

<script>
import ClassicEditor from "@ckeditor/ckeditor5-editor-classic/src/classiceditor";
import { descriptionConfig } from "../ckeditor/configs";
import DescriptionWrapper from "../Description/DescriptionWrapper.vue";
import InputHider from "../InputHider/InputHider.vue";
import Messages from "../components/Messages.vue";

import {
  createDescription,
  deleteDescription,
  updateDescription,
  getDescription,
} from "../helpers/DescriptionApi";

export default {
  name: "DescriptionContainer",
  inject: ['user'],
  components: { DescriptionWrapper, InputHider, Messages },
  data() {
    return {
      entityId: null,
      entityName: null,
      description: null,
      toggleClass: null,
      editorText: '',
      editor: ClassicEditor,
      editorConfig: descriptionConfig,
      loaded: false,
      editMode: false,
      point: 15,
      commentPoints: 2,
      messages: [],
    }
  },
  methods: {
    saveCallback(result) {
      this.clearMessages();
      this.description = result.data;
      this.editorText = '';
      this.editMode = false;
      this.messages.push({
        success: true,
        isSave: true,
      });
    },

    errorCallBack() {
      this.messages.push({
        error: true,
        isError: true,
      });
    },

    saveDescription(data) {
      updateDescription(data).then(res => {
        this.saveCallback(res);
      }).catch(() => this.errorCallBack());
    },

    createDescription() {
      let data = {};
      data[this.entityName] = this.entityId;
      data['text'] = this.editorText;

      createDescription(data).then(res => {
        this.saveCallback(res);
      }).catch(() => this.errorCallBack());
    },

    deleteDescription() {
      deleteDescription(this.description.id).then(res => {
        this.description = null;
        this.editorText = '';

        this.messages.push({
          success: true,
          isDelete: true,
        });
      }).catch(() => this.errorCallBack());
    },

    toggleEditMode() {
      this.editMode = !this.editMode;
    },

    reload() {
      if (this.description) {
        getDescription(this.description.id).then(res => {
          this.description = res.data;
        });
      }
    },

    clearMessages() {
      this.messages = [];
    }
  },
  mounted() {
    this.entityId = this.$el.parentNode.getAttribute('data-vue-description-entity-id') || null;
    this.entityName = this.$el.parentNode.getAttribute('data-vue-entity-name') || null;
    this.toggleClass = this.$el.parentNode.getAttribute('data-vue-entity-toggle-class') || null;
    const description_id = this.$el.parentNode.getAttribute('data-vue-description-id') || null;
    this.points = parseInt(this.$el.parentNode.getAttribute('data-vue-entity-points')) || 15;
    this.commentPoints = parseInt(this.$el.parentNode.getAttribute('data-vue-comment-points')) || 2;

    if (description_id) {
      getDescription(description_id).then(res => {
        this.description = res.data;
        this.loaded = true;
      })
    } else {
      this.loaded = true;
    }
  }
}
</script>

<style scoped>

</style>
